import { gql } from '@apollo/client';

export const UPDATE_SITE_COLLABORATOR_LEVEL_MUTATION = gql`
  mutation UpdateSiteCollaboratorLevelMutation(
    $siteId: String!
    $userId: String!
    $level: Int!
  ) {
    updateSiteCollaboratorLevel(siteId: $siteId, userId: $userId, level: $level)
  }
`;
